<template>
  <div class="container">
    <img class="BT" src="@/assets/images/BT.png" alt="" style="z-index: 1002;">
    <img src="@/assets/images/mb/mb_top.png" class="mengb page_head" :class="{headTitle:animate}" alt=""
         style="z-index: 1000;">

    <div class="mapBg">
      <VRComponent style="width: 100%;height: 100%"></VRComponent>
    </div>

    <div class="zjhz_btn" @click="goExpertSystem">点击跳转专家会诊系统</div>

    <div class="tab-box" style="z-index: 1000;" :class="{tabTransfer:animate}">
      <video id="tabBg" autoplay loop muted src="@/assets/video/tab/tab_bg.webm"></video>
      <div class="tabList">
        <div
            v-for="(item,index) in tabList"
            :key="index"
            :class="{active:currentRouter == index}"
            class="tabList-item"
            @click="goPage(item.name)"
        >
          <video v-if="currentRouter == item.name" autoplay muted :src="item.video"></video>
          <img v-if="currentRouter != item.name" :src="item.icon" alt="">
          <span v-if="currentRouter != item.name">{{ item.name }}</span>
        </div>
      </div>
    </div>

    <img style="z-index: 1000;" src="@/assets/images/mb/mb_bottom.png" class="mban" :class="{tabTransfer:animate}"
         alt="">

    <mqjcDialog :mqjcDialog_show="mqjcDialog_show" :type="type"/>

    <router-view style="z-index: 2000;"></router-view>
  </div>
</template>

<script>
import flowStatistics from "@/views/components/flowStatistics.vue"
import mqjcDialog from "@/views/components/seedlingMonitoring/mqjcDialog.vue"
import v1 from '@/assets/video/map_entrance.mp4'
import v2 from '@/assets/video/map_continue.mp4'

import VRComponent from '@/components/VR/index.vue'

import {Viewer} from 'photo-sphere-viewer'
import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'

import infoPopup from "@/components/infoPopup"
import {encryptData} from "@/utils/encrypt"

// import msgScroll from "@/views/components/msgScroll.vue"
export default {
  components: {flowStatistics, mqjcDialog, infoPopup, VRComponent},
  data() {
    return {
      play: false,  // 地图（循环）播放与否
      animate: false,
      mqjcDialog_show: false,
      tabList: [
        {
          name: '园区风采',
          icon: require("@/assets/images/tab/yqgl.png"),
          video: require("@/assets/video/tab/yqgl.webm"),
          url: '/page/parkOverview'
        },
        {
          name: '数据监测',
          icon: require("@/assets/images/tab/sjjc.png"),
          video: require("@/assets/video/tab/sjjc.webm"),
          url: '/page/dataMonitoring'
        },
        {
          name: '园区监控',
          icon: require("@/assets/images/tab/mqjk.png"),
          video: require("@/assets/video/tab/mqjk.webm"),
          url: '/page/seedlingMonitoring'
        },
      ],
      imgList: [
        {
          name: '场景一',
          img: './ys_空中_2.jpg'
        },
        {
          name: '场景二',
          img: './ys_空中_1.jpg'
        },
        {
          name: '场景三',
          img: './ys_空中_3.jpg'
        },
      ],
      currentRouter: '数据监测',
      type: '数据监测',

      video1: v1,
      video2: v2,

    }
  },
  watch: {
    '$route': {
      immediate: true,
      handler(newValue) {
        // this.currentRouter = newValue.name
        this.currentRouter = newValue.name
        // console.log("newValue @@@@ ",newValue);
      }
    },
  },
  created() {
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  mounted() {
    this.animate = true
    // this.createVideo(this.video1,false,true,true)
  },
  methods: {
    // 跳转专家咨询系统
    goExpertSystem(){
         window.open('https://iotcloud.sc-iot.cn:8444/main/yanjiang')
    },

    useTime() {
      if (this.currentNum > 100) {
        return
      }
      this.currentNum++
      requestAnimationFrame(this.useTime)
    },

    createVideo(src, loop, muted, autoplay) {
      let video = document.createElement('video')
      let video2 = document.createElement('video')
      video.style.width = '100%'
      video.src = src
      video.loop = loop
      video.muted = muted
      video.autoplay = autoplay
      this.$refs.mapBg.appendChild(video)
      video.onended = e => {
        // console.log("播放结束");
        video2.style.width = '100%'
        video2.src = this.video2
        video2.loop = true
        video2.muted = muted
        video2.autoplay = autoplay
      }
      video2.onloadeddata = e => {
        // console.log("video2加载");
        video.pause();
        video.removeAttribute('src'); // empty source
        // video.load();
        this.$refs.mapBg.replaceChild(video2, video)
      }
    },
    goPage(name) {
      // this.$router.push({path:url})
      if (name == '园区监控') {
        // this.type = '园区监控'
        // this.mqjcDialog_show = true
        // this.currentRouter = '园区监控'
        const cs = encryptData();
        window.open('https://hy.cdtele.cn/guyee-dolphin/remote/jump?token=' + cs)
      } else if (name == '数据监测') {
        this.currentRouter = '数据监测'
        this.mqjcDialog_show = false
        this.$router.push({path: '/page/dataMonitoring'})
      } else if (name == '园区风采') {
        // this.mqjcDialog_show = true
        this.type = '园区风采'
        this.currentRouter = '园区风采'
        this.mqjcDialog_show = false
        this.$router.push({path: '/page/parkOverview'})

      }
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  color: #fff;
  font-size: 20px;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .vrIcon {
    position: absolute;
    top: 30px;
    left: 650px;
    width: 26px;
    height: 26px;
    z-index: 2;
    cursor: pointer;
  }

  .BT {
    width: 100%;
    position: fixed;
    top: 20px;
    z-index: 2;
  }

  .page_head {
    // margin: -200px 0 -110px 0;
    width: 100%;
    transition: all 0.8s;
    position: fixed;
    z-index: 1;
  }

  .headTitle {
    margin-top: -85px;
    position: fixed;
    z-index: 1;
  }

  .mengb {
    width: 1919px;
    height: 101px;
    margin-top: 0;
    position: fixed;
    z-index: 1;
    opacity: .8;
  }

  .mapShow {
    opacity: 1;
    transition: all 1s;
  }

  .mapBg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    // z-index: -1;
    // background: lightblue;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .zjhz_btn{
    color: #39c0ff;
    font-size: 20px;
    border-bottom: 1px solid #39c0ff;
    padding: 2px 0;
    cursor: pointer;
    position: absolute;
    top: 80px;
    right: 20px;
    z-index: 2100 !important;
  }

  .tab-box {
    width: 100%;
    position: absolute;
    bottom: -130px;
    transition: all 0.8s;
    z-index: 2100 !important;

    #tabBg {
      height: 133px;
    }

    .tabList {
      width: 100%;
      display: flex;
      justify-content: center;
      position: absolute;
      bottom: 35px;

      .tabList-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 48px;
        }

        > img {
          width: 50px;
        }

        span {
          margin-top: 4px;
          font-size: 14px;
          color: rgba(255, 255, 255, 1);
        }

        video {
          width: 50px;
        }
      }
    }
  }

  .mban {
    width: 100%;
    position: absolute;
    bottom: -130px;
  }

  .tabTransfer {
    bottom: 0;
  }

}
</style>
